<template>
<div class="chapter">
<div class="inner_page">
<div class="signup-top">
<p class="signup-head">Thank you for downloading this Simon &amp; Schuster ebook.</p>
<p class="signup-texttop">Get a FREE ebook when you join our mailing list. Plus, get updates on new releases, deals, recommended reads, and more from Simon &amp; Schuster. Click below to sign up and see terms and conditions.</p>
</div>
<div class="signup-middle">
<p class="signup-clickhere"><a href="https://www.simonandschuster.com/ebook-signup/front/9781501130991" target="_blank" title="Simon &amp; Schuster Mailing List Sign-up Link">CLICK HERE TO SIGN UP</a></p>
</div>
<div class="signup-bottom">
<p class="signup-textbottom">Already a subscriber? Provide your email again so we can register this ebook and send you more of what you like to read. You will continue to receive exclusive offers in your inbox.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SS_US_adult_signup_front.vue?2f418f54